<script setup>
import { nextTick, ref, watch } from 'vue'

const props = defineProps({
  show: Boolean,
  title: { type: String, default: 'Підтвердьте дію' },
  confirmLabel: { type: String, default: 'Видалити' },
  busy: Boolean,
})
defineEmits(['confirm', 'cancel'])
const cancelButton = ref(null)
watch(() => props.show, async (show) => {
  if (show) { await nextTick(); cancelButton.value?.focus() }
})
</script>

<template>
  <Teleport to="body">
    <div v-if="show" class="catalog-modal-backdrop" @keydown.esc="$emit('cancel')">
      <div class="catalog-modal card shadow" role="alertdialog" aria-modal="true" aria-labelledby="confirm-title">
        <div class="card-body p-4">
          <h2 id="confirm-title" class="h5">{{ title }}</h2>
          <div class="text-muted"><slot>Пов’язані записи можуть заблокувати цю операцію.</slot></div>
          <div class="d-flex justify-content-end gap-2 mt-4">
            <button ref="cancelButton" type="button" class="btn btn-outline-secondary" :disabled="busy" @click="$emit('cancel')">Скасувати</button>
            <button type="button" class="btn btn-danger" :disabled="busy" @click="$emit('confirm')">
              <span v-if="busy" class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>{{ confirmLabel }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>
